import { DOCUMENT } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Team, User } from '@athlete-x/definitions';
import { AuthService } from '@athlete-x/features/auth/services/auth.service';
import { DirectoryService } from '@athlete-x/features/directory';
import { TeamStore, UserStore } from '@athlete-x/stores';
import { MenuController, ModalController } from '@ionic/angular';
import { combineLatest, map, tap } from 'rxjs';
import { GlobalService } from '@athlete-x/services/global.service';
import { MessageBoardService } from '@athlete-x/features/message-board';

@Component({
    selector: 'atx-authenticated',
    templateUrl: 'authenticated.component.html',
    styleUrls: ['authenticated.component.scss'],
})
export class AuthenticatedComponent {
    private _globalService = inject(GlobalService);
    private _currentTeam!: Team;
    private _user!: User;

    public vm$ = combineLatest([
        this._userStore.user$,
        this._userStore.currentWorkPosition$,
        this._teamStore.team$,
        this._teamStore.links$,
        this._teamStore.teamPlan$,
        this._directoryService.isGlobal$
    ])
        .pipe(
            map(([user, currentCompany, team, links, plan, isGlobal]) => ({
                user,
                currentCompany,
                jobsTitles: currentCompany?.title.split(', ').filter(jb => jb),
                team,
                links,
                plan,
                isGlobal
            })),
            tap((data) => {
                this._currentTeam = data.team;
                this._user = data.user;
            })
            // tap((data) => console.log('Authenticated ==> ', data))
        );

    constructor(
        private _auth: AuthService,
        private _userStore: UserStore,
        private _teamStore: TeamStore,
        private _directoryService: DirectoryService,
        private _menuCtrl: MenuController,
        private _router: Router,
        private _messageBoardService: MessageBoardService,
        private _modalCtrl: ModalController,

        @Inject(DOCUMENT) private _document: Document,
    ) {
    }

    public logout() {
        this._auth.logout(true, true);
    }

    public onChangeRoute(routeData: { route: string, slug: string }) {
        const { slug, route } = routeData;

        if (slug) {
            this._navigateAndRefresh(slug + '/' + route);
        } else {
            this._router
                .navigate(['/' + route])
                .then(() => this.toggleMenu());
        }

    }

    public onNavigateToGlobal() {
        if (this._user.global) {
            this._router.navigate(['global']);
        } else {
            this.onChangeGlobalAccess();
        }
    }

    public toggleMenu() {
        this._menuCtrl.toggle('main-menu');
    }

    public onTeamClicked(team?: Team) {
        if (team) {
            const slug = team.slug;
            const currentTeamSlug = this._currentTeam.slug;

            if (team.status !== 'active' && slug === currentTeamSlug) {
                return;
            }

            if (slug === currentTeamSlug) {
                this._navigate('private');

            } else {
                this._navigateAndRefresh(slug);
            }
        }
    }

    public onChangeGlobalAccess() {
        this._globalService.openChangeAccessModal()
            .then(global => {
                if (global) {
                    // this._navigate('global');
                } else if (!global && this._currentTeam.status !== 'pending') {
                    this._navigate('private');
                }
            });
    }

    public onNewMessageClick() {
        this._messageBoardService.postNewMessage();
    }

    private _navigateAndRefresh(slug: string) {
        const redirect = this._document?.baseURI + slug;
        this._document.location.href = redirect;
    }

    private _navigate(param: string) {
        this._router
            .navigate([param === 'global' ? 'global' : '/']);
    }

}
